// src/app/shared/components/ui/NavigationLoadingOverlay.tsx
import React from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'
import './LoadingOverlay.scss'

interface LoadingOverlayProps {
  isVisible: boolean
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
}) => {
  if (!isVisible) return null

  return (
    <div className='loading-overlay'>
      <div className='loading-content'>
        <ProgressSpinner
          style={{ width: '150px', height: '150px' }}
          strokeWidth='2'
          animationDuration='.8s'
        />
        <span className='loading-text'>Carregando....</span>
      </div>
    </div>
  )
}
